import { useState, useCallback, useEffect } from 'react';

function useHeightContainer(deps = []) {
  const [heightContainer, setHeightContainer] = useState(0);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const depsArray = Array.isArray(deps) ? deps : [];
  const containerRef = useCallback(
    (node) => {
      const createHeight = () => {
        if (node !== null) {
          let height = windowHeight - node.getBoundingClientRect().top;
          setHeightContainer(height);
        }
      };
      createHeight();
    },
    [windowHeight, ...depsArray]
  ); /* 
  AE: Need to track what impact it will have on performance
  [location, needScroll, parameter, trialBannerHeight, windowHeight] */

  useEffect(() => {
    const changeHeight = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', changeHeight);
    return () => {
      window.removeEventListener('resize', changeHeight);
    };
  }, []);

  return /** @type {[number, (node: HTMLElement | null) => void]} */ ([heightContainer, containerRef]);
}

export { useHeightContainer };
